import { GenericResponseWithPayload } from 'src/types/generic';
import { GET } from '../../../../utils/requestUtils';
import { GlobalSearchResponse } from '../types/globalSearchTypes';

export const fetchGlobalSearchResults = (searchTerm: string): Promise<GenericResponseWithPayload<GlobalSearchResponse>> => GET('api/search/search', {
  searchTerm,
});
